<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { LinkTextPrimary } from '@shared/ui/links'

defineOptions({
  name: 'DisciplineReportField',
})

withDefaults(defineProps<{
  title: string
  text: string
  linkUrl?: string
  metric?: boolean
  boxed?: boolean
}>(), {
  linkUrl: undefined,
  metric: false,
  boxed: false,
})
</script>

<template>
  <div :class="['discipline-report-field', { 'discipline-report-field--metric': metric, boxed }]">
    <AppText
      name="body2"
      :color="boxed ? 'slate-900' : 'slate-500'"
    >
      {{ title }}
    </AppText>
    <div class="discipline-report-field__value">
      <LinkTextPrimary
        v-if="linkUrl"
        :href="linkUrl"
        target="_blank"
      >
        {{ text }}
      </LinkTextPrimary>
      <AppText
        v-else
        :name="metric ? 'h3' : 'body1'"
        color="slate-900"
        class="discipline-report-field__text"
      >
        {{ text }}
      </AppText>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineReportField.scss" />
